import { ReactElement } from "react";
import styles from "./header.module.css";
import JustworksLogo from "assets/svg/justworks-logo-email-11-2-20.png";
import HeaderDropdown from "./headerDropdown";
import { isTestUser } from "utils/helper";
import { SystemIcon } from "@justworkshr/milo-components";

const Header = (): ReactElement => {
  const splitPath = window.location.pathname.split("/");
  const basePath = splitPath[1] || "";
  let headerClassName = styles.header;

  const getHeaderTitle = () => {
    switch (basePath) {
      case "health-insurance-application":
      case "pre-qualification":
      case "census-and-current-information":
      case "health-application-status":
        return "Health Insurance";
      case "worker-comp-application":
        return "Workers' Compensation";
      default:
        return "";
    }
  };

  return (
    <div
      className={headerClassName}
      aria-label="app-header"
      data-testid="app-header"
    >
      <div className={styles.headerLeft}>
        <img
          className={styles.image}
          src={JustworksLogo}
          alt="justworks logo"
        />
      </div>
      {isTestUser ? (
        <SystemIcon
          iconName="person"
          color="neutral"
          title="person"
          size="extra-small"
          className={styles.personSvg}
        />
      ) : (
        <div className={styles.headerRight}>
          <span className={styles.headerText}>{getHeaderTitle()}</span>
          <HeaderDropdown />
        </div>
      )}
    </div>
  );
};

export default Header;
